// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17Xll","largestCol":"styles_largestCol__2xYBm","smallestCol":"styles_smallestCol__2nrVE"};